import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';
import { CONFIG } from '../../../meta/types/config';
import { ServerNewsEntry } from '../../../meta/types/news';

const { GET } = api;

const RESOURCE_BASE_PATH = `${CONFIG.dashboardServiceBasePath}/dashboard/v1/news`;

export interface NewsResource {
  getNews: ResourceFetch<NewsResponse>;
}

export type NewsResponse = {
  member: ServerNewsEntry[];
};

const NewsResource: NewsResource = {
  getNews: GET(`${RESOURCE_BASE_PATH}`),
};

export default NewsResource;
